
export default class Room {

	static getHolderSelectors = () => ['.room-element'];

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		const features = holderElement.querySelector('.features');
		if (features) {
			const featuresObserver = new IntersectionObserver(entries => {
				if (!entries[0].isIntersecting) {
					return;
				}
				features.classList.add('scrolled');
				featuresObserver.disconnect();
			});
			featuresObserver.observe(features);
		}



		const headerPosition = document.querySelector('.header-position-holder');
		headerPosition.classList.add('d-none');

		const header = document.querySelector('header');
		header.classList.add('unpinned');
		let pinned = false;
		const navObserver = new IntersectionObserver(entry => {
			if (entry[0].isIntersecting && pinned) {
				holderElement.classList.remove('pinned');
				pinned = false;
			} else if (!entry[0].isIntersecting && !pinned) {
				holderElement.classList.add('pinned');
				pinned = true;
			}
		});
		navObserver.observe(header);

		const gallery = holderElement.querySelector('.gallery');
		if (gallery) {
			GLightbox({
				touchNavigation: true,
				loop: false,
				autoplayVideos: false
			});
		}
	}

}
